import { Injectable } from "@angular/core";
import { Generateur } from "src/app/domain/Dialyse/generateur";
import { PrelevementGenerateurDialyse } from "src/app/domain/Dialyse/prelevement-generateur-dialyse";
import { Flacon } from "src/app/domain/flacon";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { FlaconRepository } from "./flacon.repository";
import { PrelevementGenerateurRepository } from "./prelevement-generateur.repository";
import { GenerateurEntity } from "../generateur.entity";
import { InterventionEntity } from "../intervention.entity";
import { PrelevementGenerateurDialyseEntity } from "../prelevement-generateur.entity";
import { FlaconEntity } from "../flacon.entity";

@Injectable({
    providedIn: 'root',
})
export class GenerateurRepository {

    constructor(
        private flaconRepository: FlaconRepository,
        private prelevementGenerateurRepository: PrelevementGenerateurRepository,
    ) { }

    async changeGenerateurTaskStatus(gen: Generateur) {
        const ge = await this.getGenerateurEntityByCode(gen.Code)
        if (!ge || !ge.Id) {
            return;
        }
        await db.generateurs.update(ge.Id, {
            TaskStatus: gen.TaskStatus
        });
        return true;
    }

    async getGenerateurEntityById(id: number) {
        return await db.generateurs.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async getGenerateurById(id: number) {
        return await db.generateurs.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, GenerateurEntity, Generateur);
            if (ze?.PrelevementGenerateurDialyseIds) {
                for (let i = 0; i < ze.PrelevementGenerateurDialyseIds.length; i++) {
                    z.PrelevementGenerateurDialyseList.push(await this.prelevementGenerateurRepository.getPrelevementGenerateurDialyseById(ze.PrelevementGenerateurDialyseIds[i]));
                }
            }

            return z;
        });
    }

    async getGenerateurEntityByCode(code: string) {
        return await db.generateurs.where('Code').equals(code).first(async me => {
            return me;
        });
    }

    async getGenerateurByCodeWithChildren(code: string) {
        return await db.generateurs.where('Code').equals(code).first(async ze => {
            const z = mapper.map(ze, GenerateurEntity, Generateur);

            if (ze?.PrelevementGenerateurDialyseIds) {
                for (let i = 0; i < ze.PrelevementGenerateurDialyseIds.length; i++) {
                    z.PrelevementGenerateurDialyseList.push(await this.prelevementGenerateurRepository.getPrelevementGenerateurDialyseById(ze.PrelevementGenerateurDialyseIds[i]));
                }
            }

            return z;
        });
    }

    async attachGenerateur(app: Generateur, interventionEntity: InterventionEntity) {
        let appId: number;
        const ge = mapper.map(app, Generateur, GenerateurEntity);

        // const ie = await this.interventionRepository.getInterventionEntityById(interventionId);
        ge.Id = await db.generateurs.add(ge);
        interventionEntity.GenerateurIds = interventionEntity?.GenerateurIds ? [...interventionEntity.GenerateurIds, ge.Id] : [ge.Id]
        await db.interventions.update(interventionEntity.Id!, {
            GenerateurIds: interventionEntity?.GenerateurIds
        });

        if (app.PrelevementGenerateurDialyseList?.length > 0) {
            for (let i = 0; i < app.PrelevementGenerateurDialyseList.length; i++) {
                await this.prelevementGenerateurRepository.attachPrelevementGenerateurDialyse(app.PrelevementGenerateurDialyseList[i], ge);
            }
        }

        return ge.Id;
    }

    async updateGenerateur(app: Generateur) {
        let zme = await this.getGenerateurEntityByCode(app.Code);
        if (!zme || !zme.Id) {
            return false;
        }

        if (zme.PrelevementGenerateurDialyseIds.length > 0) {
            for (let i = 0; i < zme.PrelevementGenerateurDialyseIds?.length; i++) {
                let pae = await this.prelevementGenerateurRepository.getPrelevementGenerateurEntityById(zme.PrelevementGenerateurDialyseIds[i]);
                if (pae) {
                    mapper.mutate(app.PrelevementGenerateurDialyseList[i], pae, PrelevementGenerateurDialyse, PrelevementGenerateurDialyseEntity);
                    await db.prelevementGenerateurs.update(zme.PrelevementGenerateurDialyseIds[i], pae);

                    for (let j = 0; j < app.PrelevementGenerateurDialyseList[i].Prelevement.FlaconList.length; j++) {
                        let fe = await this.flaconRepository.getFlaconEntityByCode(app.PrelevementGenerateurDialyseList[i].Prelevement.FlaconList[j].Code);
                        if (fe && fe.Id) {
                            mapper.mutate(app.PrelevementGenerateurDialyseList[i].Prelevement.FlaconList[j], fe, Flacon, FlaconEntity);
                            await db.flacons.update(fe.Id, app.PrelevementGenerateurDialyseList[i].Prelevement.FlaconList[j]);
                        }
                    }
                }
            }
        }

        mapper.mutate(app, zme, Generateur, GenerateurEntity);
        await db.generateurs.update(zme.Id, zme);

        return true;
    }
}